import { actionRetryable, createRequestTypes } from '@/utils/actions.utils'
import { isProduction } from '@/utils/env.utils'
import { action } from '@/utils/actions.utils'

export const SET_ERROR = 'SET_ERROR'
const setError = (error) => {
	if (!isProduction()) {
		console.error(error)
	}
	return {
		type: SET_ERROR,
		error: new Error(error),
		showError: true,
	}
}

export const CLEAR_ERROR = 'CLEAR_ERROR'
const clearError = () => {
	return {
		type: CLEAR_ERROR
	}
}

export const ACTION_ALLOW_RETRY = createRequestTypes('ACTION_ALLOW_RETRY')
export const actionAllowRetry = (action) => {
	return async (dispatch) => {
		const res = await dispatch(action)
		if (res.error) {
			await dispatch(queueAction(action))
			return dispatch(failure(res.error))
		} else {
			return dispatch(success(res))
		}
	}
	function queueAction(payload) {
		return actionRetryable('RETRY_ACTION_QUEUE_ACTION', payload)
	}
	function success(payload) {
		return actionRetryable(ACTION_ALLOW_RETRY.SUCCESS, payload)
	}
	function failure(err) {
		return actionRetryable(ACTION_ALLOW_RETRY.FAILURE, null, err, false)
	}
}

export const RETRY_ACTION = {
	"QUEUE_ACTION": "RETRY_ACTION_QUEUE_ACTION",
	"SHOW_CTA": "RETRY_ACTION_SHOW_CTA",
	"RETRY": "RETRY_ACTION_RETRY",
	"RESET": "RETRY_ACTION_RESET",
}
const queueAction = (pendingAction) => {
	const payload = pendingAction
	return action(RETRY_ACTION.QUEUE_ACTION, payload, null, false)

}
const resetActions = () => {
	return action(RETRY_ACTION.RESET, {}, null, false)
}
const retryActions = () => {
	return action(RETRY_ACTION.RETRY, {}, null, false)
}
const showRetryCta = () => {
	return action(RETRY_ACTION.SHOW_CTA, {}, null, false)
}

export default {
	setError,
	clearError,
	queueAction,
	actionAllowRetry,
	resetActions,
	retryActions,
	showRetryCta
}
